import { useGraph } from '@spazious/dollhouse-store';
import { InputText, Typography } from '@spazious/dollhouse-uikit';

import { useSelectedNodes } from '../../hooks/index.js';

import { Grid } from './Grid.js';
export interface MetaFieldProps {
  label: string;
  field: string;
  multiple?: boolean;
  disabled?: boolean;
  onChange: (fieldName: string, value: string) => void;
  value: string;
}

export const MetaField: React.FC<MetaFieldProps> = ({
  multiple = true,
  label,
  field,
  disabled,
  value,
  onChange,
}) => {
  const { graph } = useGraph();
  const selected = useSelectedNodes();
  const selectedShallowNodes = selected.map((node) => graph.shallow.nodes[node.selector!]);

  if (multiple === false && selectedShallowNodes.length > 1) {
    return null;
  }

  return (
    <Grid>
      <Typography size="large" style={{ flex: 1 }} variant="label">
        {label}:{' '}
      </Typography>
      <InputText
        disabled={disabled}
        placeholder={selectedShallowNodes.length > 1 ? ' Multiple values' : ''}
        value={value}
        onChange={(evt) => onChange(field, evt.target.value)}
      />
    </Grid>
  );
};
